module.exports = "<div class=\"s-loading\">\n\n    <spinner></spinner>\n\n    <p>Loading</p>\n\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/page/views/loading.html
// module id = 758
// module chunks = 0